import {
  AnchorTargetParams,
  DynamicPlaceholderParams,
  RenderingProps,
  TranslationOptionsParams,
} from 'src/shared/shared.types';

export type B02HeroBannerCarouselProps = RenderingProps<
  unknown,
  B02HeroBannerCarouselParams,
  HeroBannerCarouselPlaceholder
>;

export type B02HeroBannerCarouselParams = {
  SlideTiming?: number;
  LeftAlignOnMobile?: boolean;
} & DynamicPlaceholderParams &
  TranslationOptionsParams &
  AnchorTargetParams;

export type HeroBannerCarouselPlaceholder = {
  'hero-banner-carousel-container-{*}'?: {
    componentName?: string;
  }[];
};
